import { takeEvery, takeLatest } from 'core/middlewares/utilities';
import { Bff } from 'core/services';
import * as useCases from 'core/use-cases';

/**
 * Map use-cases request action types to corresponting BFF endpoints
 *
 */
export const actionResourceMapper = {
  [useCases.user.actions.cyclesFetch.request.type]: Bff.endpoints.cyclesGet,
  [useCases.cart.actions.cartFetch.request.type]: Bff.endpoints.cartGet,
  [useCases.cart.actions.cartCurrentDeliveryFetch.request.type]: Bff.endpoints.cartGet,
  [useCases.cart.actions.lastCartFetch.request.type]: Bff.endpoints.hybridLastCartGet,
  [useCases.cart.actions.cartFetchForGiftsCheck.request.type]: Bff.endpoints.cartGet,
  [useCases.cart.actions.cartSetShippingModelFetch.request.type]:
    Bff.endpoints.cartSetShippingModel,
  [useCases.cart.actions.clearCouponFetch.request.type]: Bff.endpoints.cartSetCoupon,
  [useCases.cart.actions.itemAddFetch.request.type]: Bff.endpoints.cartItemUpdate,
  [useCases.cart.actions.itemDeleteFetch.request.type]: Bff.endpoints.cartItemUpdate,
  [useCases.cart.actions.itemUpdateFetch.request.type]: Bff.endpoints.cartItemUpdate,
  [useCases.cart.actions.setCouponFetch.request.type]: Bff.endpoints.cartSetCoupon,
  [useCases.checkout.actions.promotionFetch.request.type]: Bff.endpoints.promotionFetch,
  [useCases.catalog.actions.catalogFetch.request.type]: Bff.endpoints.catalogGet,
  [useCases.catalog.actions.searchPreviousFetch.request.type]: Bff.endpoints.catalogGet,
  [useCases.catalog.actions.catalogNextPageFetch.request.type]: Bff.endpoints.catalogGet,
  [useCases.checkout.actions.createOrderFetch.request.type]: Bff.endpoints.orderCreate,
  [useCases.checkout.actions.createOrderFetchNewFlow.request.type]:
    Bff.endpoints.orderCreateNewFlow,
  [useCases.checkout.actions.paymentDetailFetch.request.type]: Bff.endpoints.paymentDetailsSet,
  [useCases.checkout.actions.specialPaymentsFetch.request.type]: Bff.endpoints.specialPaymentsGet,
  [useCases.checkout.actions.paymentDetailNewFlowFetch.request.type]:
    Bff.endpoints.paymentDetailsSetNewFlow,
  [useCases.checkout.actions.paymentMethodsFetch.request.type]: Bff.endpoints.paymentMethodsGet,
  [useCases.checkout.actions.processFetch.request.type]: Bff.endpoints.processGet,
  [useCases.combo.actions.comboFetch.request.type]: Bff.endpoints.comboGet,
  [useCases.combo.actions.comboPost.request.type]: Bff.endpoints.comboPost,
  [useCases.order.actions.orderFetch.request.type]: Bff.endpoints.orderGet,
  [useCases.search.actions.searchFetch.request.type]: Bff.endpoints.searchGet,
  [useCases.showcases.actions.showcasesFetch.request.type]: Bff.endpoints.catalogGet,
  [useCases.showcases.actions.availableShowcasesFetch.request.type]:
    Bff.endpoints.availableShowcasesGet,
  [useCases.productDetail.actions.productDetailFetch.request.type]: Bff.endpoints.productDetailGet,
  [useCases.content.actions.starlinkPageFetch.request.type]: Bff.endpoints.starlinkPageGet,
  [useCases.content.actions.starlinkContentFetch.request.type]: Bff.endpoints.starlinkContentGet,

  [useCases.user.actions.creditFetch.request.type]: Bff.endpoints.userCreditGet,
  [useCases.user.actions.userBuyIntentionFetch.request.type]: Bff.endpoints.userBuyIntention,
  [useCases.user.actions.userFetch.request.type]: Bff.endpoints.authDetail,
  [useCases.user.actions.userResaleIntention.request.type]: Bff.endpoints.resellerIntention,
  [useCases.shippingModel.actions.currentDeliveryModeFetch.request.type]:
    Bff.endpoints.currentDeliveryMode,
  [useCases.shippingModel.actions.availableDeliveryModesFetch.request.type]:
    Bff.endpoints.availableDeliveryModes,
  [useCases.user.actions.changeCycle.request.type]: Bff.endpoints.changeCyclePost,
  [useCases.catalog.actions.getResellerAvailableCatalogs.request.type]:
    Bff.endpoints.getResellerAvailableCatalogs,
  [useCases.user.actions.incentiveCampaignsListFetch.request.type]:
    Bff.endpoints.incentiveCampaignsListGet,
} as const;

/**
 * List of all registered Bff Actions Types
 *
 */
export const actions = [
  [useCases.user.actions.userResaleIntention.request.type, takeLatest],
  [useCases.content.actions.starlinkPageFetch.request.type, takeLatest],
  [useCases.content.actions.starlinkContentFetch.request.type, takeLatest],
  [useCases.showcases.actions.availableShowcasesFetch.request.type, takeLatest],
  [useCases.user.actions.cyclesFetch.request.type, takeLatest],
  [useCases.cart.actions.cartFetchForGiftsCheck.request.type, takeLatest],
  [useCases.cart.actions.cartFetch.request.type, takeLatest],
  [useCases.cart.actions.lastCartFetch.request.type, takeLatest],
  [useCases.cart.actions.cartCurrentDeliveryFetch.request.type, takeLatest],
  [useCases.cart.actions.cartSetShippingModelFetch.request.type, takeLatest],
  [useCases.cart.actions.clearCouponFetch.request.type, takeLatest],
  [useCases.cart.actions.itemAddFetch.request.type, takeLatest],
  [useCases.cart.actions.itemDeleteFetch.request.type, takeLatest],
  [useCases.cart.actions.itemUpdateFetch.request.type, takeLatest],
  [useCases.cart.actions.setCouponFetch.request.type, takeLatest],
  [useCases.catalog.actions.catalogFetch.request.type, takeLatest],
  [useCases.catalog.actions.searchPreviousFetch.request.type, takeLatest],
  [useCases.catalog.actions.catalogNextPageFetch.request.type, takeLatest],
  [useCases.checkout.actions.createOrderFetch.request.type, takeLatest],
  [useCases.checkout.actions.createOrderFetchNewFlow.request.type, takeLatest],
  [useCases.checkout.actions.paymentDetailFetch.request.type, takeLatest],
  [useCases.checkout.actions.paymentDetailNewFlowFetch.request.type, takeLatest],
  [useCases.checkout.actions.paymentMethodsFetch.request.type, takeLatest],
  [useCases.checkout.actions.specialPaymentsFetch.request.type, takeLatest],
  [useCases.checkout.actions.promotionFetch.request.type, takeLatest],
  [useCases.checkout.actions.processFetch.request.type, takeLatest],
  [useCases.combo.actions.comboFetch.request.type, takeLatest],
  [useCases.combo.actions.comboPost.request.type, takeLatest],
  [useCases.order.actions.orderFetch.request.type, takeLatest],
  [useCases.search.actions.searchFetch.request.type, takeLatest],
  [useCases.showcases.actions.showcasesFetch.request.type, takeEvery],
  [useCases.user.actions.creditFetch.request.type, takeLatest],
  [useCases.user.actions.userBuyIntentionFetch.request.type, takeLatest],
  [useCases.user.actions.userFetch.request.type, takeLatest],
  [useCases.shippingModel.actions.availableDeliveryModesFetch.request.type, takeLatest],
  [useCases.shippingModel.actions.currentDeliveryModeFetch.request.type, takeLatest],
  [useCases.user.actions.changeCycle.request.type, takeLatest],
  [useCases.catalog.actions.getResellerAvailableCatalogs.request.type, takeLatest],
  [useCases.productDetail.actions.productDetailFetch.request.type, takeLatest],
  [useCases.user.actions.incentiveCampaignsListFetch.request.type, takeLatest],
] as const;
